"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
import {
  AccreOverImg,
  CardBody,
  CardContent,
  CommonCard,
  ContentContainer,
  Layout,
  Stack,
  SubHeading,
  TP,
} from "../../../components/molecules";
import { Autoplay, Navigation } from "swiper/modules";
import Image from "next/image";
import { getImageUrl, getImageUrlNew } from "../../../lib/util";

const RoundShape = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="111"
      height="109"
      viewBox="0 0 111 109"
      fill="none"
      className="absolute right-0 bottom-0"
    >
      <path
        d="M21.4839 91.7572C21.4839 110.947 6.99078 108.59 0 109H111V0.00012207C111 7.45323 107.883 12.7658 104.369 16.229C100.292 20.2474 94.2628 20.938 88.5381 20.938H69.4839C42.9742 20.938 21.4839 42.4283 21.4839 68.938V91.7572Z"
        fill="#000"
      />
    </svg>
  );
};

export default function CaseStudyCarousel({ data = [] }) {
  return (
    <Layout className="caseStudy">
      <ContentContainer>
        <Stack>
          <Swiper
            loop={true}
            autoplay={{
              // delay: 2000,
              disableOnInteraction: false,
            }}
            speed={1000}
            spaceBetween={30}
            // slidesPerView={2.5}
            navigation={true}
            onSlideChange={() => {}}
            modules={[Navigation]}
            className="relative curriculum"
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 1.9,
                spaceBetween: 30,
              },
            }}
          >
            {data?.length > 0 && (
              <span slot="container-start">
                <AccreOverImg className="top-[-1px] !left-[-1px] z-20 rotate-x caseStudyShape" />
              </span>
            )}
            {data.map((item, index) => (
              <SwiperSlide key={index}>
                <CommonCard className="sessionCard">
                  <CardBody session className="lg:min-h-[580px]">
                    <CardContent session>
                      <Stack className="justify-start lg:justify-end">
                        <Image
                          loading="lazy"
                          src={getImageUrlNew(item?.attachment, "small")}
                          alt="No Image"
                          height={70}
                          width={175}
                        />
                      </Stack>
                      <div className="mt-11 lg:mt-20">
                        <h3 className="mt-8 mb-4 lg:mb-8 text-2xl font-extrabold leading-normal text-black">
                          {item?.title}
                        </h3>
                        <TP size="14px">{item?.description}</TP>
                      </div>
                    </CardContent>
                  </CardBody>
                </CommonCard>
              </SwiperSlide>
            ))}
          </Swiper>
        </Stack>
      </ContentContainer>
    </Layout>
  );
}
